import script from "./VisitedViews.vue?vue&type=script&setup=true&lang=js"
export * from "./VisitedViews.vue?vue&type=script&setup=true&lang=js"

import "./VisitedViews.vue?vue&type=style&index=0&id=57f7c514&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-57f7c514"]])

export default __exports__